import { render, staticRenderFns } from "./ODSModal.vue?vue&type=template&id=09b31b04&"
import script from "./ODSModal.vue?vue&type=script&lang=js&"
export * from "./ODSModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports